export default __webpack_public_path__ + "static/media/raiffeisen_logo.1ae0985d.svg";